import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ActionTypes as optionsActionTypes } from '../../actions/dashboard/actions-options';
import { Update as ReportUpdateAction } from '../../actions/dashboard/actions-report';
import { concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class EffectsDashboard {
  updateDashboard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(optionsActionTypes.Change),
      concatMap(_ => of(new ReportUpdateAction()))
    )
  });

  constructor(private readonly actions$: Actions) { }
}
